// extracted by mini-css-extract-plugin
export default {"spinner":"MenuPublicationStatus_spinner__kgmtU"};